import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const QualificationExperiences = () => {
  AOS.init({
    delay: 500,
    duration: 1000,
    offset: 120,
    mirror: false,
    anchorPlacement: "top-bottom",
  });

  return (
    <div className="progress-journey flex  transition-all">
      <ul className="journey-description">
        <li data-aos="fade-right" className="mb-4">
          <h2 className="text-md">System Engineer</h2>
          <h5 className="f-gray">| Candy Corner Philippines</h5>
          <span className="text-sm f-gray d-block">
            | 108 E Rodriguez Jr. Avenue, Bagumbayan, Libis, Unit G&H, 2nd Floor, ARAGA Building, Quezon City, Metro Manila 1110, PH
          </span>
          <span className="text-sm f-gray d-block">| Full-Time</span>
          <span className="text-sm f-gray">| November 2025 - Present</span>
        </li>

        <li data-aos="fade-right" className="mb-4">
          <h2 className="text-md">Junior System Developer</h2>
          <h5 className="f-gray">| Wilcon Depot, Inc.</h5>
          <span className="text-sm f-gray d-block">
            | 90 E. Rodriguez Jr. Ave., Ugong Norte Libis Q. C.
          </span>
          <span className="text-sm f-gray d-block">| Full-Time</span>
          <span className="text-sm f-gray">| August 2024 - November 2025</span>
        </li>

        <li data-aos="fade-right" className="mb-4">
          <h2 className="text-md">Software Developer</h2>
          <h5 className="f-gray">| Freelance</h5>
          <span className="text-xs f-gray d-block">| Part-Time</span>
          <span className="text-sm f-gray">| July 2023 - June 2024</span>
        </li>

        <li data-aos="fade-right">
          <h2 className="text-lg">
            WordPress Developer
            <br />
          </h2>
          <h5 className="f-gray">
            | Wedding Suppliers Association of the Philippines Inc.
          </h5>
          <span className="text-xs f-gray d-block">
            | Cavite Office Conrado Commercial Complex Bldg 2 Aguinaldo Highway,
            4102
          </span>
          <span className="text-xs f-gray d-block">| Internship</span>
          <span className="text-xs f-gray">| February 2024 - March 2024</span>
        </li>
      </ul>
    </div>
  );
};

export default QualificationExperiences;
